import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { ProductTomos } from './components/ProductTomos';
import { Bonuses } from './components/Bonuses';
import { CoachSection } from './components/CoachSection';
import { Testimonials } from './components/Testimonials';
import { UrgencyBanner } from './components/UrgencyBanner';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="flex w-full min-h-full flex-col bg-white font-sans" data-id="element-0" data-mp="2whx9xpepbgdl">
      <Hero data-id="element-1" data-mp="28t4ju9krg2qw" />
      <PainPoints data-id="element-2" data-mp="28sl3gxardmez" />
      <Solution data-id="element-3" data-mp="28s2x37udtrtc" />
      <ProductTomos data-id="element-4" data-mp="23vkw8j26adma" />
      <Bonuses data-id="element-5" data-mp="23w4e5zrtp20b" />
      <CoachSection data-id="element-6" data-mp="23ujk0b9f7l2z" />
      <Testimonials data-id="element-7" data-mp="23v2sl1d6kx4c" />
      <UrgencyBanner data-id="element-8" data-mp="23ti5txx3yih1" />
      <FAQSection data-id="element-9" data-mp="3ikh7o8icgqyg" />
      <FinalCTA data-id="element-10" data-mp="3iiweonbohg2p" />
      <Footer data-id="element-11" data-mp="3ijfvu1ti80fo" />
      <StickyMobileCTA data-id="element-12" data-mp="3ijpef4c7z5bc" />
      <RecentPurchaseToast data-id="element-13" data-mp="3mlj82snzz920" />
      <div className="h-16 sm:hidden" aria-hidden="true" data-id="element-14" data-mp="3mkrc3gqhn9b7" />
    </div>;
}